const capitalize = (str: string) =>
  str.replace(/\S*/g, txt => txt.charAt(0).toUpperCase() + txt.slice(1));

export default capitalize;
